import { render, staticRenderFns } from "./Holdings.vue?vue&type=template&id=7167ae9a&scoped=true&"
import script from "./Holdings.vue?vue&type=script&lang=js&"
export * from "./Holdings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7167ae9a",
  null
  
)

export default component.exports